// -----------------------------------------------------------
// FloraIQ — Aba Fontes e Evidências
// -----------------------------------------------------------

import { sourceInconsistencies } from "@/mocks/quality";
import { ValidationStatusBadge } from "./QualityStatusBadge";

export default function SourceEvidenceValidationPanel() {
  return (
    <div className="space-y-6">
      {/* Painéis resumo */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-3">
        {[
          { label: "Fontes Ausentes", value: sourceInconsistencies.filter((s) => s.fonteAtual === "Nenhuma" || s.fonteAtual === "Não registrada").length, icon: "ri-file-unknow-line", color: "red" },
          { label: "Evidências Fotográficas Pendentes", value: sourceInconsistencies.filter((s) => s.tipoFonteEsperada.includes("Foto")).length, icon: "ri-camera-off-line", color: "orange" },
          { label: "Documentos Vencidos", value: sourceInconsistencies.filter((s) => s.problema.includes("Vencid") || s.problema.includes("vencid")).length, icon: "ri-calendar-close-line", color: "red" },
          { label: "Documentos sem Vínculo", value: sourceInconsistencies.filter((s) => s.problema.includes("sem")).length, icon: "ri-links-line", color: "yellow" },
          { label: "Fotos sem Metadados", value: sourceInconsistencies.filter((s) => s.problema.includes("data")).length, icon: "ri-image-edit-line", color: "orange" },
          { label: "Laudos Incompletos", value: sourceInconsistencies.filter((s) => s.tipoFonteEsperada.includes("Laudo") || s.tipoFonteEsperada.includes("Parecer")).length, icon: "ri-file-warning-line", color: "yellow" },
        ].map((p) => (
          <div key={p.label} className="bg-white rounded-card border border-background-200/70 p-3">
            <div className="flex items-center gap-2 mb-1">
              <div className={`w-7 h-7 rounded-lg flex items-center justify-center ${
                p.color === "red" ? "bg-red-100 text-red-600" : p.color === "orange" ? "bg-orange-100 text-orange-600" : "bg-yellow-100 text-yellow-600"
              }`}>
                <i className={`${p.icon} text-xs`}></i>
              </div>
              <span className="text-xs font-medium text-foreground-600 truncate">{p.label}</span>
            </div>
            <p className="text-lg font-bold font-heading text-foreground-900">{p.value}</p>
          </div>
        ))}
      </div>

      {/* Tabela */}
      <div className="overflow-x-auto border border-background-200/70 rounded-card">
        <table className="w-full text-xs">
          <thead>
            <tr className="bg-background-50 border-b border-background-200/70">
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Unidade</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Tipo de Fonte Esperada</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Fonte Atual</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Problema</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Status</th>
              <th className="text-left px-3 py-2.5 font-medium text-foreground-600">Ação Recomendada</th>
              <th className="text-center px-3 py-2.5 font-medium text-foreground-600">Ações</th>
            </tr>
          </thead>
          <tbody>
            {sourceInconsistencies.map((s) => (
              <tr key={s.id} className="border-b border-background-100 hover:bg-background-50/50 transition-colors">
                <td className="px-3 py-2.5 font-mono text-foreground-700">{s.unidade}</td>
                <td className="px-3 py-2.5 text-foreground-600">{s.tipoFonteEsperada}</td>
                <td className="px-3 py-2.5 text-foreground-500 max-w-[120px] truncate">{s.fonteAtual}</td>
                <td className="px-3 py-2.5 text-foreground-700 max-w-[220px] truncate">{s.problema}</td>
                <td className="px-3 py-2.5"><ValidationStatusBadge status={s.status} /></td>
                <td className="px-3 py-2.5 text-foreground-600 max-w-[220px] truncate">{s.acaoRecomendada}</td>
                <td className="px-3 py-2.5 text-center">
                  <button className="w-7 h-7 rounded-lg flex items-center justify-center hover:bg-background-100 transition-colors cursor-pointer" title="Vincular fonte">
                    <i className="ri-link text-foreground-500 text-sm"></i>
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}